import Globals from './globals';

// PDFs open in a new tab via a hidden form POST, which can't set an Authorization header,
// so the API also accepts the bearer token from an access_token form field.
export function appendAuthToken(form) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "access_token";
    input.value = Globals.bearer || '';
    form.appendChild(input);
}
